<template>
    <SdsTable></SdsTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../Layouts/GuestLayout.vue")
);
const SdsTable = defineAsyncComponent(() =>
    import("../../components/Safety/SDSTable/SDSTable.vue")
);

export default {
    name: "SDS_TableUnauth", //The name you are in should not equal the name of the component you are importing.
    components: { SdsTable, GuestLayout },
    layout: [GuestLayout],
};
</script>
